/**
 * Normalize customer payloads from GET /v1/customer/info (camelCase model vs snake_case DB).
 */
function str(v) {
  if (v == null || v === false) return '';
  if (typeof v === 'number' && Number.isFinite(v)) return String(v);
  if (typeof v !== 'string') return String(v).trim();
  return v.trim();
}

function pick(obj, camel, snake) {
  if (!obj || typeof obj !== 'object') return '';
  const a = str(obj[camel]);
  if (a) return a;
  return str(obj[snake]);
}

/**
 * Unwrap nested API shapes (e.g. { customer: { ... } }).
 */
export function normalizeCustomerPayload(payload) {
  if (!payload || typeof payload !== 'object') return null;
  if (payload.customer && typeof payload.customer === 'object') {
    return payload.customer;
  }
  if (
    payload.data &&
    typeof payload.data === 'object' &&
    (payload.data.id != null || payload.data.entityName != null)
  ) {
    return payload.data;
  }
  return payload;
}

export function isAdministratorRole(role) {
  const normalized = String(role || '').toLowerCase();
  return normalized === 'administrator' || normalized === 'admin';
}

function isAddressBlockComplete(obj, prefix) {
  const isBilling = prefix === 'billing';
  const street = isBilling
    ? pick(obj, 'billingAddress', 'billing_address')
    : str(obj.address);
  const city = isBilling ? pick(obj, 'billingCity', 'billing_city') : str(obj.city);
  const state = isBilling ? pick(obj, 'billingState', 'billing_state') : str(obj.state);
  const country = isBilling
    ? pick(obj, 'billingCountry', 'billing_country')
    : str(obj.country);

  if (!street || !country) return false;
  return !!(city || state);
}

/**
 * True when billing-specific address is complete, or primary business address is complete
 * (many tenants use the same address; the banner should not stay up in that case).
 * City may be omitted when state is provided (common for some address formats).
 */
export function isBillingInfoComplete(info) {
  const data = normalizeCustomerPayload(info);
  if (!data) return false;

  if (isAddressBlockComplete(data, 'billing')) return true;
  return isAddressBlockComplete(data, 'primary');
}
